const BASE_SHELVES_AMOUNT = 250;
const GRAPHIC_WAREHOUSE_QUERY_PAGE_SIZE = 500;
const GRAPHIC_WAREHOUSE_CRAFT_FILTER = { column: 'TYPE', value: "collect_graphics" };
const GRAPHIC_WAREHOUSE_ORDER_BY = [ { column: 'ID', order: 'DESC' } ];

const normalizeShelfNumber = (value) => {
    if (value === null || value === undefined)
    {
        return "";
    }

    return String(value).trim();
};

const getStandardShelfLabels = (amount = BASE_SHELVES_AMOUNT) => (
    Array.from({ length: amount }, (_, index) => String(index + 1))
);

const getStandsFromCursor = (data) => data?.standsCursor?.edges?.map(edge => edge.node) || [];

const fetchRemainingStandPages = ({ data, loading, fetchMore }) => {
    const pageInfo = data?.standsCursor?.pageInfo;

    if (loading || !fetchMore || !pageInfo?.hasNextPage)
    {
        return;
    }

    fetchMore({
        variables: {
            after: pageInfo.endCursor
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
            if (!fetchMoreResult?.standsCursor?.edges?.length)
            {
                return previousResult;
            }

            return {
                ...previousResult,
                standsCursor: {
                    ...fetchMoreResult.standsCursor,
                    edges: [
                        ...(previousResult?.standsCursor?.edges || []),
                        ...fetchMoreResult.standsCursor.edges
                    ]
                }
            };
        }
    });
};

const buildShelfAvailability = (stands, baseShelvesAmount = BASE_SHELVES_AMOUNT) => {
    const standardLabels = getStandardShelfLabels(baseShelvesAmount);
    const standardSet = new Set(standardLabels);
    const occupiedMap = new Map();

    stands.forEach((stand) => {
        const shelfNumber = normalizeShelfNumber(stand?.shelf_number);

        if (!shelfNumber)
        {
            return;
        }

        const shelfStands = occupiedMap.get(shelfNumber) || [];
        occupiedMap.set(shelfNumber, [ ...shelfStands, stand ]);
    });

    const occupiedLabels = new Set(occupiedMap.keys());
    const freeStandardLabels = standardLabels.filter(label => !occupiedLabels.has(label));
    const extraLabels = Array.from(occupiedLabels)
        .filter(label => !standardSet.has(label))
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" }));
    const labels = [ ...standardLabels, ...extraLabels ];

    return {
        standardLabels,
        labels,
        occupiedMap,
        occupiedLabels,
        freeStandardLabels,
        amountShelves: labels.length,
        occupiedShelves: occupiedLabels.size,
        emptyShelves: labels.length - occupiedLabels.size,
        extraLabels
    };
};

const buildMatchedShelves = (stands) => (
    new Set(
        stands
            .map(stand => normalizeShelfNumber(stand?.shelf_number))
            .filter(Boolean)
    )
);

const isShelfLabelOccupied = (occupiedLabels, value) => (
    occupiedLabels.has(normalizeShelfNumber(value))
);

const ShelfAvailabilityHelper = {
    BASE_SHELVES_AMOUNT,
    GRAPHIC_WAREHOUSE_QUERY_PAGE_SIZE,
    GRAPHIC_WAREHOUSE_CRAFT_FILTER,
    GRAPHIC_WAREHOUSE_ORDER_BY,
    normalizeShelfNumber,
    getStandardShelfLabels,
    getStandsFromCursor,
    fetchRemainingStandPages,
    buildShelfAvailability,
    buildMatchedShelves,
    isShelfLabelOccupied
};

export {
    BASE_SHELVES_AMOUNT,
    GRAPHIC_WAREHOUSE_QUERY_PAGE_SIZE,
    GRAPHIC_WAREHOUSE_CRAFT_FILTER,
    GRAPHIC_WAREHOUSE_ORDER_BY,
    normalizeShelfNumber,
    getStandardShelfLabels,
    getStandsFromCursor,
    fetchRemainingStandPages,
    buildShelfAvailability,
    buildMatchedShelves,
    isShelfLabelOccupied
};

export default ShelfAvailabilityHelper;
